import { render } from "./BtnAtivarDesativar.vue?vue&type=template&id=51ece75f"
import script from "./BtnAtivarDesativar.vue?vue&type=script&lang=js"
export * from "./BtnAtivarDesativar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__